import * as imageAPIUtil from 'utils/api/images';
import * as embedAPIUtil from 'utils/api/embed';
import { settingCustomImage } from 'state/actions/embedsState/embedManagementState/content_status';
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
// import { setContentChangeState } from 'state/actions/embedsState/embedManagementState/content_status';
import { displayErrorMessage, displaySuccessMessage } from '@insticator/insticator-ui'; // iui-state
import { receiveContentData, updateContentData } from 'state/actions/embedsState/embedManagementState/content_status';
import { setEditMode, browserAlertOff } from '@insticator/insticator-ui'; // iui-utils

// utils
import { batchActions } from "redux-batched-actions";

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const SET_EMBED_PLACEMENT = 'SET_EMBED_PLACEMENT';
export const TOGGLE_AD = 'TOGGLE_AD';
export const TOGGLE_ADD_ON_ITEM = 'TOGGLE_ADD_ON_ITEM';
export const SET_ADS = 'SET_ADS';
export const SET_VIDEO_ADS = 'SET_VIDEO_ADS';
export const SET_EMBED_PROPERTY = 'SET_EMBED_PROPERTY';
export const SET_EDITING_ADD_ON = 'SET_EDITING_ADD_ON';
export const SET_PARTNER_LOGO_SRC = 'SET_PARTNER_LOGO_SRC';
export const SET_PARTNER_LOGO_URL = 'SET_PARTNER_LOGO_URL';
export const TOGGLE_INSTICATOR_BRANDING = 'TOGGLE_INSTICATOR_BRANDING';
export const SET_EMBED_PROPERTIES = 'SET_EMBED_PROPERTIES';
export const RECEIVE_EMBED_DATA = 'RECEIVE_EMBED_DATA';
export const RESET_EMBED_STATE = 'RESET_EMBED_STATE';
export const SET_EMBED_CREATED_STATUS = 'SET_EMBED_CREATED_STATUS';
export const SHOW_PARTNER_LOGO = 'SHOW_PARTNER_LOGO';
export const DISCARD_EMBED_CHANGES = 'DISCARD_EMBED_CHANGES';
export const RECEIVE_EMBED_CODE = 'RECEIVE_EMBED_CODE';
export const ATTACH_LABEL = 'ATTACH_LABEL';
export const REMOVE_LABEL = 'REMOVE_LABEL';


// ACTIONS THAT CAN BE IMPORTED AND USED IN COMPONENTS

export const setEditingAddOn = addOn => ({
    type: SET_EDITING_ADD_ON,
    addOn
});

export const setEmbedPlacement = placement => ({
    type: SET_EMBED_PLACEMENT,
    placement
});

export const toggleAd = adToToggle => ({
    type: TOGGLE_AD,
    adToToggle
});

export const setAds = (ad1, ad2, overlay, mobile) => ({
    type: SET_ADS,
    mobile,
    ad1,
    ad2,
    overlay
});

export const setVideoAds = (device, value) => ({
    type: SET_VIDEO_ADS,
    device,
    value
});

export const setEmbedProperty = (property, value) => ({
    type: SET_EMBED_PROPERTY,
    property,
    value
});

export const setEmbedProperties = properties => ({
    type: SET_EMBED_PROPERTIES,
    properties
});

export const toggleAddOnItem = itemToToggle => ({
    type: TOGGLE_ADD_ON_ITEM,
    itemToToggle
});

export const setPartnerLogoUrl = url => ({
    type: SET_PARTNER_LOGO_URL,
    url
});

export const toggleInsticatorBranding = () => ({
    type: TOGGLE_INSTICATOR_BRANDING
});

export const receiveEmbedData = embedData => ({
    type: RECEIVE_EMBED_DATA,
    embedData
});

export const resetEmbedState = initialEmbedData => ({
    type: RESET_EMBED_STATE,
    initialEmbedData
});

export const attachLabel = labelUUID => ({
    type: ATTACH_LABEL,
    labelUUID
});

export const removeLabel = labelUUID => ({
    type: REMOVE_LABEL,
    labelUUID
})

const receiveEmbedCode = code => ({
    type: RECEIVE_EMBED_CODE,
    code
});

// Action setEmbedCreatedStatus is handeled in both selectedEmbedStatus and contentStatus reducers
const setEmbedCreatedStatus = status => ({
    type: SET_EMBED_CREATED_STATUS,
    status
});
export const discardEmbedChanges = () => ({
    type: DISCARD_EMBED_CHANGES
});
export const setPartnerLogoSrc = logoSource => ({
    type: SET_PARTNER_LOGO_SRC,
    logoSource
});
export const partnerLogoUploadSuccess = (logoSource) => batchActions([
    settingCustomImage(false),
    setPartnerLogoSrc(logoSource)
]);
export const partnerLogoUploadFail = err => batchActions([
    receiveError(err),
    settingCustomImage(false),
    displayErrorMessage('There was an issue uploading your Logo')
]);
const receiveError = (error) => {
    console.log('contentStatusActionsError', error);
};
const turnEditStateAlertsOff = () => dispatch => {
    browserAlertOff();
    return dispatch(setEditMode(false));
};

export const createEmbed = (siteUUID, data) => dispatch => {
    dispatch(setEmbedProperty('isSavingData', true));
    return embedAPIUtil.createEmbed(siteUUID, data)
        .then(response => dispatch(setEmbedCreatedStatus(response.data)),
            err => (receiveError(err)))
        .then(() => dispatch(updatePageDetails('dashboard/embeds/management/code')))
        .then(() => dispatch(updateStepDetails('code')))
        .then(() => dispatch(changePage('dashboard/embeds/management/code')))
        .then(() => dispatch(turnEditStateAlertsOff()))
        .catch((error) => {
            if(error.response && (error.response.status === 500)) {
                dispatch(updatePageDetails('error/500'));
                dispatch(changePage('error/500'));
            }
        })
};
export const updateEmbed = (siteUUID, embedUUID, data) => dispatch => {
    dispatch(setEmbedProperty('isSavingData', true));
    return embedAPIUtil.updateEmbed(siteUUID, embedUUID, data)
        .then(response => dispatch(batchActions([
                updateContentData(response.data.contents),
                receiveEmbedData({ ...response.data.embed, ...response.data.site }),
                displaySuccessMessage('Your embed has been updated successfully!')
        ])))
        .catch((error) => {
            if(error.response && (error.response.status === 500)) {
                dispatch(updatePageDetails('error/500'));
                dispatch(changePage('error/500'));
            }
        })
};
export const getEmbedCode = (siteUUID, embedUUID) => dispatch => (
    embedAPIUtil.requestEmbedCode(siteUUID, embedUUID)
        .then(response => dispatch(receiveEmbedCode(response.data)),
            err => (dispatch(batchActions([
                receiveEmbedCode(err),
                displayErrorMessage('There was an issue fetching your Header and Body code')])
            ))
        )
);
export const updatePartnerLogo = (accountUUID, imageFile) => dispatch => {
    dispatch(settingCustomImage(true));
        imageAPIUtil.uploadImage(accountUUID, imageFile, true, 'CUSTOMIZE')
            .then(response => dispatch(partnerLogoUploadSuccess(response.data[0])),
                err => (partnerLogoUploadFail(err)))

};
export const toggleShowPartnerLogo = (bool) => ({
    type: SHOW_PARTNER_LOGO,
    bool
});
